import { ANALYTICS_IDENTITY } from 'dashboard/constants/appEvents';
import AnalyticsHelper from 'dashboard/helper/AnalyticsHelper';
import { emitter } from 'shared/helpers/mitt';

export const initializeAnalyticsEvents = () => {
  AnalyticsHelper.init();
  emitter.on(ANALYTICS_IDENTITY, ({ user }) => {
    AnalyticsHelper.identify(user);
  });
};
